
import { useLoading } from '@/contexts/LoadingContext';
import { useCallback } from 'react';

export const useActionLoading = () => {
  const { setLoading, isLoading, getLoadingMessage } = useLoading();

  const setActionLoading = useCallback((actionKey: string, loading: boolean, message: string = 'Processing...') => {
    setLoading(`action-${actionKey}`, loading, message, 'action');
  }, [setLoading]);

  const setFormLoading = useCallback((formKey: string, loading: boolean, message: string = 'Saving...') => {
    setLoading(`form-${formKey}`, loading, message, 'action');
  }, [setLoading]);

  const setDataLoading = useCallback((dataKey: string, loading: boolean, message: string = 'Loading...') => {
    setLoading(`data-${dataKey}`, loading, message, 'data');
  }, [setLoading]);

  const isActionLoading = useCallback((actionKey: string) => {
    return isLoading(`action-${actionKey}`);
  }, [isLoading]);

  const isFormLoading = useCallback((formKey: string) => {
    return isLoading(`form-${formKey}`);
  }, [isLoading]);

  const isDataLoading = useCallback((dataKey: string) => {
    return isLoading(`data-${dataKey}`);
  }, [isLoading]);

  const getActionLoadingMessage = useCallback((actionKey: string) => {
    return getLoadingMessage(`action-${actionKey}`);
  }, [getLoadingMessage]);

  return {
    setActionLoading,
    setFormLoading,
    setDataLoading,
    isActionLoading,
    isFormLoading,
    isDataLoading,
    getActionLoadingMessage
  };
};
